import React from 'react';
import { ErrorState } from '../../../CommonComponents/OPL/AsyncStates/ErrorState/ErrorState';
import { AsyncStateCard } from '../AsyncStateCard/AsyncStateCard';

interface Props {
  onRetry?(): void;
}

export const OrionRiskToleranceWorkflowError: React.FC<Props> = ({ onRetry }) => {
  return (
    <AsyncStateCard>
      <ErrorState onAction={onRetry} />
    </AsyncStateCard>
  );
};
